import {useLayoutEffect} from "react";

const MOBILE_MQ = "(max-width: 768px)";

function syncMobileFixedPageHero(hero) {
    if (!hero) return;

    const mq = window.matchMedia(MOBILE_MQ);
    const container = hero.closest(".common-container, .detail-list-layout");

    if (!mq.matches) {
        hero.classList.remove("mobile-page-hero--fixed");
        container?.style.removeProperty("--mobile-page-hero-spacer");
        return;
    }

    hero.classList.add("mobile-page-hero--fixed");
    const height = hero.offsetHeight;
    container?.style.setProperty("--mobile-page-hero-spacer", `${height + 10}px`);
}

/** 모바일에서 페이지 hero를 viewport 상단(nav 아래)에 fixed 고정 */
export function useMobileFixedPageHero(heroRef) {
    useLayoutEffect(() => {
        const hero = heroRef.current;
        if (!hero) return undefined;

        const mq = window.matchMedia(MOBILE_MQ);
        const handleChange = () => syncMobileFixedPageHero(hero);
        const ro = new ResizeObserver(handleChange);

        handleChange();
        ro.observe(hero);
        mq.addEventListener("change", handleChange);

        return () => {
            ro.disconnect();
            mq.removeEventListener("change", handleChange);
            hero.classList.remove("mobile-page-hero--fixed");
            hero.closest(".common-container, .detail-list-layout")?.style.removeProperty("--mobile-page-hero-spacer");
        };
    }, [heroRef]);
}
